<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const props = defineProps({
  area: {
    type: String,
    required: true
  }
})
const areaListTitle = '周辺エリアの黄砂レーダー'
const prefList = areaToPrefTable.find(({ key }) => key === props.area).pref_list
</script>

<template>
  <section class="satelliteList">
    <SectionTitle :title="areaListTitle" />
    <div class="content">
      <NuxtLink
        v-for="pref in prefList"
        :key="pref.key"
        :to="`/${pref.key}/`"
        class="link"
      >
        {{ pref.name }}
      </NuxtLink>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.satelliteList {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .content {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px;
    border-radius: 6px;
    background-color: #EEF1F8;
  }
  .link {
    padding: 7px 10px;
    border-radius: 4px;
    background-color: #FFF;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / .15);
    color: #303030;
    font-size: 13px;
    font-weight: 600;
    line-height: 1em;
  }
  @media (any-hover: hover) {
    .link {
      transition: opacity .2s ease-in-out;
      cursor: pointer;
      &:hover {
        opacity: .6;
      }
    }
  }
}
</style>
